import { RouteInterface } from "src/common";
import config from "src/config";
import { NotFoundPage } from "src/pages/global/notFound/notFound.page";
import CheckoutPageAdditional from "../additional/checkout/checkout.page";
import CheckoutExecutePaymentPageAdditional from "../additional/checkout/checkoutExecutePayment.page";
import CheckoutExecutePaymentWithInstallmentsPageAdditional from "../additional/checkout/checkoutExecutePaymentWithInstallments.page";
import CheckoutFailureAdditionalPage from "../additional/checkout/checkoutFailure.page";
import CheckoutPaymentSentPageAdditional from "../additional/checkout/checkoutPaymentSent.page";
import CheckoutPaymentSentWithInstallmentsPageAdditional from "../additional/checkout/checkoutPaymentSentWithInstallments.page";
import CheckoutSuccessAdditionalPage from "../additional/checkout/checkoutSuccess.page";
import CustomerDataPage from "../additional/customer/customerData.page";
import CustomerOnlyDatePage from "../additional/customer/customerOnlyDate.page";
import CustomerOnlyDateBrziPregledPage from "../additional/customer/customerOnlyDateBrziPregled.page";
import HealthExamsPage from "../additional/health/healthExams.page";
import HealthQuestionnairePage from "../additional/health/healthQuestionnaire.page";
import HealthQuestionnaireAgentPage from "../additional/health/healthQuestionnaireAgent.page";
import HealthQuestionnaireConfirmationNeededPage from "../additional/health/healthQuestionnaireConfirmationNeeded.page";
import HealthQuestionnairPrintPage from "../additional/health/healthQuestionnairePrint.page";
import HealthQuestionnaireRejectedPage from "../additional/health/healthQuestionnaireRejected.page";
import AgentOffersPreviewPage from "../additional/offers/agentOffersPreview.page";
import { NoOfferPage } from "../additional/offers/noOffer.page";
import OfferAdditionalPage from "../additional/offers/offer.page";
import OffersAdditionalPreviewPage from "../additional/offers/offersAdditionalPreview.page";
import RenewalPage from "../additional/renewal/renewal.page";
import TermsAndConditionsPageAdditional from "../additional/offers/termsAndConditions.page";
import ThankYouPage from "../additional/success/thankYou.page";
import RootPage from "../root.page";
import CheckoutPage from "../supplementary/checkout/checkout.page";
import CheckoutPageB from "../supplementary/checkout/checkoutB.page";
import CheckoutExecutePaymentPage from "../supplementary/checkout/checkoutExecutePayment.page";
import CheckoutExecutePaymentWithInstallmentsPage from "../supplementary/checkout/checkoutExecutePaymentWithInstallments.page";
import CheckoutFailurePage from "../supplementary/checkout/checkoutFailure.page";
import CheckoutPaymentSentPage from "../supplementary/checkout/checkoutPaymentSent.page";
import CheckoutPaymentSentWithInstallmentsPage from "../supplementary/checkout/checkoutPaymentSentWithInstallments.page";
import CheckoutReminderFinalPage from "../supplementary/checkout/checkoutReminderFinal.page";
import CheckoutSuccessPage from "../supplementary/checkout/checkoutSuccess.page";
import CustomerPage from "../supplementary/customer/customer.page";
import CustomerContractNowPage from "../supplementary/customer/customerContractNow.page";
import CustomerWithDatePage from "../supplementary/customer/customerWithDate.page";
import CustomerWithDateNewPage from "../supplementary/customer/customerWithDateNew.page";
import CustomerPolicyComparisonPage from "../supplementary/customer/customerPolicyComparison.page";
import MboPage from "../supplementary/mbo/mbo.page";
import MboThankYouPage from "../supplementary/mbo/mboThankYou.page";
import OfferPage from "../supplementary/offers/offer.page";
import OffersPage from "../supplementary/offers/offers.page";
import OffersPageB from "../supplementary/offers/offersB.page";
import OffersPreviewPage from "../supplementary/offers/offersPreview.page";
import OffersPreviewPageB from "../supplementary/offers/offersPreviewB.page";
import TermsAndConditionsPage from "../supplementary/offers/termsAndConditions.page";
import SoPage from "../supplementary/so/so.page";
import CustomerBrziPregledPage from "../supplementary/customer/customerBrziPregled.page";
import { AppRoutes, AppRoutesAdditional, AppRoutesAdditionalCrossell } from "./app.routes";

const AppRoutingBase: Array<RouteInterface> = [
  {
    path: `${AppRoutes.ROOT.fullPath}`,
    element: () => config.REACT_APP_IS_DEV === 'true' ? RootPage() : NotFoundPage(),
    functions: []
  },
  {
    path: `${AppRoutes.CUSTOMER_DATE.fullPath}/:birthDate`,
    element: CustomerWithDatePage,
    functions: [],
    pageName: 'Personal Data Step 2'
  },
  {
    path: `${AppRoutes.CUSTOMER_DATE_NEW.fullPath}/:birthDate`,
    element: CustomerWithDateNewPage,
    functions: [],
    pageName: 'Personal Data Step 2 New'
  },
  {
    path: `${AppRoutes.CUSTOMER_CONTRACT_NOW.fullPath}/:birthDate`,
    element: CustomerContractNowPage,
    functions: [],
    pageName: 'Personal Data Contract Now'
  },
  {
    path: `${AppRoutes.CUSTOMER.fullPath}`,
    element: CustomerPage,
    functions: [],
    pageName: 'Personal Data Step 1'
  },
  {
    path: `${AppRoutes.CUSTOMER_BRZIPREGLED.fullPath}`,
    element: CustomerBrziPregledPage,
    functions: [],
    pageName: 'Personal Data Step 1 - Brzi Pregled'
  },
  {
    path: `${AppRoutes.CUSTOMER_POLICY_COMPARISON.fullPath}`,
    element: CustomerPolicyComparisonPage,
    functions: [],
    pageName: 'Customer Policy Comparison'
  },
  {
    path: `${AppRoutes.CUSTOMER_POLICY_COMPARISON.fullPath}/:comparisonParams`,
    element: CustomerPolicyComparisonPage,
    functions: [],
    pageName: 'Customer Policy Comparison'
  },
  {
    path: `${AppRoutes.OFFERS.fullPath}`,
    element: OffersPage,
    functions: [],
    pageName: 'Offers'
  },
  {
    path: `${AppRoutes.OFFER.fullPath}/:offerId`,
    element: OfferPage,
    functions: [],
    pageName: 'Contractor'
  },
  {
    path: `${AppRoutes.SO.fullPath}/:soId`,
    element: SoPage,
    functions: [],
    pageName: ''
  },
  {
    path: `${AppRoutes.CHECKOUT.fullPath}/:offerId`,
    element: CheckoutPage,
    functions: [],
    pageName: 'Choose Payment'
  },
  {
    path: `${AppRoutes.CHECKOUT_SUCCESS.fullPath}`,
    element: CheckoutSuccessPage,
    functions: [],
    pageName: 'Confirmation'
  },
  {
    path: `${AppRoutes.CHECKOUT_FAILURE.fullPath}`,
    element: CheckoutFailurePage,
    functions: [],
    pageName: 'Payment Error'
  },
  {
    path: `${AppRoutes.CHECKOUT_PAYMENT_SENT.fullPath}/:offerId`,
    element: CheckoutPaymentSentPage,
    functions: [],
    pageName: 'Plaćanje - Uplata jednokratno'
  },
  {
    path: `${AppRoutes.CHECKOUT_EXECUTE_PAYMENT.fullPath}/:offerId`,
    element: CheckoutExecutePaymentPage,
    functions: [],
    pageName: 'Skeniraj - Uplata jednokratno'
  },
  {
    path: `${AppRoutes.CHECKOUT_PAYMENT_SENT_INSTALLMENTS.fullPath}/:offerId`,
    element: CheckoutPaymentSentWithInstallmentsPage,
    functions: [],
    pageName: 'Plaćanje - Uplata na rate'
  },
  {
    path: `${AppRoutes.CHECKOUT_EXECUTE_PAYMENT_INSTALLMENTS.fullPath}/:offerId`,
    element: CheckoutExecutePaymentWithInstallmentsPage,
    functions: [],
    pageName: 'Skeniraj - Uplata na rate'
  },
  {
    path: `${AppRoutes.CHECKOUT_REMINDER_FINAL_PAGE.fullPath}`,
    element: CheckoutReminderFinalPage,
    functions: [],
    pageName: 'Internet Reminder Final'
  },
  {
    path: `${AppRoutes.MBO.fullPath}/:soId`,
    element: MboPage,
    functions: [],
    pageName: 'MBO'
  },
  {
    path: `${AppRoutes.MBO_THANK_YOU.fullPath}`,
    element: MboThankYouPage,
    functions: [],
    pageName: 'MBO Thank You'
  },
  {
    path: `${AppRoutes.OFFERS_PREVIEW.fullPath}/:age`,
    element: OffersPreviewPage,
    functions: [],
    pageName: 'Offers Preview'
  },
  {
    path: `${AppRoutes.TERMS_AND_CONDITIONS.fullPath}/:offerId`,
    element: TermsAndConditionsPage,
    functions: [],
    pageName: 'Terms and Conditions'
  }
];

// --- A/B parallel funnel (DEV-4731) -----------------------------------------
// The whole DZO funnel is registered a second time under the `-b` base segment so a bucketed
// visitor stays URL-isolated from step-1 to checkout. Every clean-base step reuses its baseline
// component except the three v2.5 redesigns, which swap to their B component. Visitors enter the
// `-b` base via the external A/B tool (VWO) at the step-1 entry; `useFunnelNavigate` then keeps
// all in-app navigation on the `-b` base. `-brzipregled` entries keep no base segment and are
// intentionally excluded.
const DZO_BASE = 'dopunsko-zdravstveno-osiguranje';
const DZO_BASE_B = 'dopunsko-zdravstveno-osiguranje-b';

const B_COMPONENT_OVERRIDES = new Map<unknown, unknown>([
  [OffersPage, OffersPageB],
  [CheckoutPage, CheckoutPageB],
  [OffersPreviewPage, OffersPreviewPageB],
]);

const AppRoutingB: Array<RouteInterface> = AppRoutingBase
  .filter((route) => route.path.includes(`${DZO_BASE}/`))
  .map((route) => ({
    ...route,
    path: route.path.replace(`${DZO_BASE}/`, `${DZO_BASE_B}/`),
    element: B_COMPONENT_OVERRIDES.get(route.element) ?? route.element,
    pageName: route.pageName ? `${route.pageName}` : route.pageName,
  }));

const AppRouting: Array<RouteInterface> = [...AppRoutingBase, ...AppRoutingB];

const AppRoutingAdditional: Array<RouteInterface> = [
  {
    path: `${AppRoutesAdditional.CUSTOMER_ONLY_DATE.fullPath}`,
    element: CustomerOnlyDatePage,
    functions: [],
    pageName: 'Personal Data Step 1'
  },
  {
    path: `${AppRoutesAdditional.CUSTOMER_ONLY_DATE_BRZIPREGLED.fullPath}`,
    element: CustomerOnlyDateBrziPregledPage,
    functions: [],
    pageName: 'Personal Data Step 1 - Brzi Pregled'
  },
  {
    path: `${AppRoutesAdditional.HEALTH_EXAMS.fullPath}/:dateOfBirth`,
    element: HealthExamsPage,
    functions: [],
    pageName: 'Health Exams Step 2'
  },
  {
    path: `${AppRoutesAdditional.CUSTOMER_DATA.fullPath}`,
    element: CustomerDataPage,
    functions: [],
    pageName: 'Customer Data Step 3'
  },
  {
    path: `${AppRoutesAdditional.THANK_YOU.fullPath}`,
    element: ThankYouPage,
    functions: [],
    pageName: 'Thank You Additional'
  },
  {
    path: `${AppRoutesAdditional.OFFERS_PREVIEW.fullPath}`,
    element: OffersAdditionalPreviewPage,
    functions: [],
    pageName: 'Offers Additional Preview'
  },
  {
    path: `${AppRoutesAdditional.OFFERS_PREVIEW.fullPath}/:soId`,
    element: OffersAdditionalPreviewPage,
    functions: [],
    pageName: 'Offers Additional Preview'
  },
  {
    path: `${AppRoutesAdditional.AGENT_OFFERS_PREVIEW.fullPath}/:soId`,
    element: AgentOffersPreviewPage,
    functions: [],
    pageName: 'Agent Offers Preview'
  },
  {
    path: `${AppRoutesAdditional.OFFER.fullPath}/:offerId`,
    element: OfferAdditionalPage,
    functions: [],
    pageName: 'Offer Additional Confirmation',
    bannerData: 'offer_details'
  },
  {
    path: `${AppRoutesAdditional.TERMS_AND_CONDITIONS.fullPath}/:offerId`,
    element: TermsAndConditionsPageAdditional,
    functions: [],
    pageName: 'Terms and Conditions'
  },
  {
    path: `${AppRoutesAdditional.CHECKOUT.fullPath}/:offerId`,
    element: CheckoutPageAdditional,
    functions: [],
    pageName: 'Choose Payment',
    bannerData: 'offer_details'
  },
  {
    path: `${AppRoutesAdditional.CHECKOUT_SUCCESS.fullPath}`,
    element: CheckoutSuccessAdditionalPage,
    functions: [],
    pageName: 'Confirmation'
  },
  {
    path: `${AppRoutesAdditional.CHECKOUT_FAILURE.fullPath}`,
    element: CheckoutFailureAdditionalPage,
    functions: [],
    pageName: 'Payment Error'
  },
  {
    path: `${AppRoutesAdditional.CHECKOUT_PAYMENT_SENT.fullPath}/:offerId`,
    element: CheckoutPaymentSentPageAdditional,
    functions: [],
    pageName: 'Plaćanje - Uplata jednokratno'
  },
  {
    path: `${AppRoutesAdditional.CHECKOUT_PAYMENT_SENT_INSTALLMENTS.fullPath}/:offerId`,
    element: CheckoutPaymentSentWithInstallmentsPageAdditional,
    functions: [],
    pageName: 'Plaćanje - Uplata na rate'
  },
  {
    path: `${AppRoutesAdditional.CHECKOUT_EXECUTE_PAYMENT.fullPath}/:offerId`,
    element: CheckoutExecutePaymentPageAdditional,
    functions: [],
    pageName: 'Skeniraj - Uplata jednokratno'
  },
  {
    path: `${AppRoutesAdditional.CHECKOUT_EXECUTE_PAYMENT_INSTALLMENTS.fullPath}/:offerId`,
    element: CheckoutExecutePaymentWithInstallmentsPageAdditional,
    functions: [],
    pageName: 'Skeniraj - Uplata na rate'
  },
  {
    path: `${AppRoutesAdditional.NO_OFFER.fullPath}`,
    element: NoOfferPage,
    functions: [],
    pageName: 'No Offer'
  },
  {
    path: `${AppRoutesAdditional.RENEWAL.fullPath}`,
    element: RenewalPage,
    functions: [],
    pageName: 'Renewal Additional'
  },
  {
    path: `${AppRoutesAdditional.HEALTH_QUESTIONNAIRE.fullPath}/:offerId`,
    element: HealthQuestionnairePage,
    functions: [],
    pageName: 'Health Questionnaire',
    bannerData: 'price_details'
  },
  {
    path: `${AppRoutesAdditional.HEALTH_QUESTIONNAIRE_REJECTED.fullPath}/:offerId`,
    element: HealthQuestionnaireRejectedPage,
    functions: [],
    pageName: 'Health Questionnaire Rejected'
  },
  {
    path: `${AppRoutesAdditional.HEALTH_QUESTIONNAIRE_NEEDS_CONFIRMATION.fullPath}/:offerId`,
    element: HealthQuestionnaireConfirmationNeededPage,
    functions: [],
    pageName: 'Health Questionnaire Needs Confirmation'
  },
  {
    path: `${AppRoutesAdditional.HEALTH_QUESTIONNAIRE_PRINT.fullPath}/:offerId`,
    element: HealthQuestionnairPrintPage,
    functions: [],
    pageName: 'Health Questionnaire Print'
  },
  {
    path: `${AppRoutesAdditional.HEALTH_QUESTIONNAIRE_AGENT.fullPath}/:offerId/:adminId`,
    element: HealthQuestionnaireAgentPage,
    functions: [],
    pageName: 'Health Questionnaire Agent'
  },
];

const AppRoutingAdditionalCrossell: Array<RouteInterface> = [
  {
    path: `${AppRoutesAdditionalCrossell.CUSTOMER_ONLY_DATE.fullPath}`,
    element: CustomerOnlyDatePage,
    functions: [],
    pageName: 'Personal Data Step 1'
  },
  {
    path: `${AppRoutesAdditionalCrossell.HEALTH_EXAMS.fullPath}/:dateOfBirth`,
    element: HealthExamsPage,
    functions: [],
    pageName: 'Health Exams Step 2'
  },
  {
    path: `${AppRoutesAdditionalCrossell.CUSTOMER_DATA.fullPath}`,
    element: CustomerDataPage,
    functions: [],
    pageName: 'Customer Data Step 3'
  }
];

export { AppRouting, AppRoutingAdditional, AppRoutingAdditionalCrossell };
